/** Page to go through the diag & PMI form flows */
import { createFileRoute, useParams } from '@tanstack/react-router'

import { MobileInspectionSubmissionPage } from '../../../../../../components/request-drawer/action/inspection_step/mobile-upload/MobileInspectionSubmissionPage'

export const Route = createFileRoute(
  '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { providerBranchId, requestId } = useParams({
    from: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission',
  })

  return <MobileInspectionSubmissionPage providerBranchId={providerBranchId} requestId={requestId} />
}
